<template>
  <div v-if="groupedRoles.length" :id="accordionName">
    <b-form-checkbox
      v-model="allSelected"
      :indeterminate="indeterminate"
      @change="toggleAll"
      :disabled="disabled || (!isAdmin && !groupedRoles.some(role => loggedUserHasRole(role)))"
      :key="selectedRoles.length"
      v-if="visibleRoles.length"
      class="d-inline-block"
    >

      <b-button
        variant="link"
        class="button-collapse"
        @click.prevent="$emit('toggleAccordion', accordionName)"
      >
        <b-icon :icon="isCollapsed ? 'chevron-right' : 'chevron-down'"
                font-scale="0.9" shift-v="4"/>
      </b-button>

      {{ group }}

    </b-form-checkbox>

    <b-collapse :visible="!isCollapsed" class="pl-3">
      <template v-for="(role) in groupedRoles">
        <b-form-checkbox
          :key="role.id"
          v-if="isAdmin || loggedUserHasRole(role) || role.oldValue"
          v-model="role.newValue"
          :value="true"
          :unchecked-value="false"
          :disabled="disabled || (!isAdmin && !loggedUserHasRole(role))">
          {{ $t(`role.${role.name}`) }}
        </b-form-checkbox>
      </template>
    </b-collapse>
  </div>
</template>

<script>
export default {
  name: 'CheckboxGroup',
  props: [
    'group',
    'groupedRoles',
    'loggedUserRole',
    'isAdmin',
    'disabled',
    'accordionName',
    'activeAccordion',
  ],
  data() {
    return {
      allSelectedValue: false,
    };
  },
  methods: {
    toggleAll(checked) {
      Object.values(this.visibleRoles).forEach((role) => {
        if (this.isAdmin || this.loggedUserHasRole(role)) {
          role.newValue = checked;
        }
      });
    },
    loggedUserHasRole(role) {
      return !!(this.loggedUserRole && this.loggedUserRole.roles.some((r) => r.id === role.id));
    },
  },
  computed: {
    isCollapsed() {
      return this.accordionName !== this.activeAccordion;
    },
    allSelected: {
      get() {
        return this.selectedRoles.length && this.selectedRoles.length === this.visibleRoles.length;
      },
      set(checked) {
        return checked;
      },
    },
    indeterminate() {
      return this.selectedRoles.length > 0
        && this.selectedRoles.length !== this.visibleRoles.length;
    },
    visibleRoles() {
      return this.groupedRoles
        .filter((role) => (this.isAdmin || role.oldValue || this.loggedUserHasRole(role)));
    },
    selectedRoles() {
      return this.visibleRoles.filter((role) => role.newValue === true);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/variables";

.button-collapse {
  border: 0;
  font-size: inherit;
  padding: 0;
}

</style>
